export default {
  SETTLING: 'CONTROL_VIEW_SETTLEmENT_SETTLING',
  SETTLED: 'CONTROL_VIEW_SETTLEMENT_SETTLED',
};
